<template>
  <v-menu
          v-model="show"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
  >
    <v-list>
      <v-list-tile
              v-for="(item, index) in items"
              :key="index"
              @click="item.action"
      >
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { LOADING_END, LOADING_START, REMOVE_WORD } from '../store/mutation-types'
import { WordsApi } from '../common/api'
import { REFRESH_SOURCE_WORDS } from '../store/action-types'

export default {
  props: ['word', 'x', 'y', 'value'],
  data () {
    return {
      show: false
    }
  },
  computed: {
    items () {
      return [
        { title: 'Edit', action: this.edit },
        { title: 'Full Image', action: this.openFullImage },
        { title: 'Remove Word', action: this.removeWord }
      ]
    }
  },
  watch: {
    value () {
      this.show = this.value
    },
    show () {
      if (this.show !== this.value) {
        this.$emit('input', this.show)
      }
    }
  },
  methods: {
    openFullImage () {
      window.open(this.word.image)
    },
    edit () {
      this.$emit('edit', this.word)
    },
    async removeWord () {
      const word = this.word
      if (!confirm(`Вы уверены что хотите удалить слово "${word.text}"`)) {
        return
      }
      this.$store.commit(LOADING_START, REMOVE_WORD)
      try {
        await WordsApi.delete(word)
        this.$store.commit(REMOVE_WORD, word)
        this.$store.dispatch(REFRESH_SOURCE_WORDS)
      } catch (e) {
        alert('Произошла ошибка при удалении слова:  ' + word.text + '. Необходимо обновить страницу!')
      } finally {
        this.$store.commit(LOADING_END, REMOVE_WORD)
      }
    }
  }
}
</script>
